import angular from 'angular';
import { retailerSettingsService } from '../services/retailer-settings/retailer-settings';
import { loadCustomCss } from '../lib/loadCustomCss';
import { setLoading } from '../actions/page';
import { store } from '../store';
import { addCustomStylesToHead } from '../lib/customStyles';

angular.module('MainCtrl', []).controller('MainController', [
  '$scope',
  '$rootScope',
  ($scope, $rootScope) => {
    $rootScope.product = retailerSettingsService.getProduct();
    const productTitle = `${$rootScope.product[0].toUpperCase()}${$rootScope.product.substring(1)}`;
    const displayName = retailerSettingsService.getDisplayName();
    const faviconUrl = retailerSettingsService.getFaviconUrl();
    const update = () => {
      $rootScope.$applyAsync(() => {
        const {
          language,
          page: { displayHelp, initialPageLoadParams },
        } = store.getState();

        $rootScope.lang = language;
        $scope.displayHelp = displayHelp;
        $scope.isOnboardingPreview = initialPageLoadParams.onboarding === 'true';

        document.title = language['returns.page_title'] || `${displayName} ${productTitle}`;
      });
    };
    store.subscribe(update);
    update();

    $rootScope.settings = retailerSettingsService.getSettings();
    $rootScope.brand = retailerSettingsService.getBrand();
    $rootScope.retailer = retailerSettingsService.getName();
    $scope.isRetailerDisabled = retailerSettingsService.getIsRetailerDisabled();

    addCustomStylesToHead();

    loadCustomCss();

    const enableFavicon = (link) => {
      let favicon = document.querySelector('link[rel="shortcut icon"]');

      if (!favicon) {
        favicon = document.createElement('link');
        favicon.setAttribute('rel', 'shortcut icon');
        const headElement = document.querySelector('head');
        headElement.appendChild(favicon);
      }

      favicon.setAttribute('type', 'image/png');
      favicon.setAttribute('href', link);
    };

    if (faviconUrl) {
      enableFavicon(faviconUrl);
    }

    store.dispatch(setLoading(false));
  },
]);
